<template>
    <div class="Aviso">
        <div class="libe_home_nav" v-if="scroll >= 88">
            <headNav :activeNav="'loan'"></headNav>
        </div>
        <div class="libe_home_wrap">
            <div class="libe_homenav" v-if="scroll < 88 ">
                <headNav :activeNav="'loan'"></headNav>
            </div>

            <div class="arrecredi_home_banner">

            </div>

            <div class="bigContent">
                <div class="content">
                    <p><span style="font-weight: bold;">Fecha de actualización:</span> 28 de abril de 2026  </p>
                    <p>
                        De conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en adelante, la “Ley”), su Reglamento y los Lineamientos del Aviso de Privacidad publicados en el Diario Oficial de la Federación el 17 de enero de 2013, YOONA TECH, S.A. DE C.V., a través de su aplicación Arrecredi, pone a su disposición el presente Aviso de Privacidad y le informa sobre los siguientes términos y condiciones:
                    </p>
                    <p style="font-weight: bold;">I. Tratamiento de los Datos Personales</p>
                    <p>
                        YOONA TECH, S.A. DE C.V. (en adelante, YOONA) y su aplicación Arrecredi, con domicilio en Calle Tonalá 59, Roma Nte., Cuauhtémoc, 06700 Ciudad de México, CDMX, es responsable de la obtención, uso, divulgación, almacenamiento, acceso, manejo, aprovechamiento, transferencia o disposición de datos personales (en adelante, “Tratamiento”).
                    </p>
                    <p style="font-weight: bold;">II. Datos Personales sujetos a Tratamiento.</p>
                    <p>
                        YOONA recabará los datos personales necesarios para cumplir con su objeto social, políticas de prevención y detección de operaciones con recursos de procedencia ilícita, financiamiento al terrorismo y demás políticas corporativas. Estos datos podrán ser recopilados de manera directa (a través de ejecutivos, funcionarios, empleados o promotores) o indirecta (mediante asesores o comisionistas), utilizando medios remotos o locales de comunicación electrónica, óptica u otra tecnología, como:
                    </p>
                    <ul>
                        <li>
                            Nuestro portal web o aplicación.
                        </li>
                        <li>
                            Correo electrónico o postal.
                        </li>
                        <li>
                            Servicios en línea.
                        </li>
                        <li>
                            Vía telefónica.
                        </li>
                    </ul>
                    <p>
                        Los datos personales recabados podrán incluir, entre otros:
                    </p>
                    <p style="font-weight: bold;">1.Datos de Identificación</p>
                    <ul>
                        <li>
                            Nombre completo, estado civil, género, fecha de nacimiento, edad, país.
                        </li>
                        <li>
                            Identificación oficial vigente, RFC, CURP, Firma Electrónica Avanzada (FIEL).
                        </li>
                        <li>
                            Correo electrónico, datos académicos, características físicas (fotografías).
                        </li>
                    </ul>
                    <p style="font-weight: bold;">2.Datos Personales</p>
                    <ul>
                        <li>
                            Información laboral, salarios mensuales, día de cobro, nivel educativo.
                        </li>
                        <li>
                            Información bancaria (tipo de cuenta, número de tarjeta).
                        </li>
                    </ul>
                    <p style="font-weight: bold;">3. Datos Comerciales</p>
                    <ul>
                        <li>
                            Fuente de ingresos, actividades empresariales, experiencia profesional.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">4. Datos Laborales</p>
                    <ul>
                        <li>
                            Actividad principal, tipo de empleo, ingresos mensuales, dirección del centro de trabajo.
                        </li>
                        <li>
                            Fecha de ingreso, cargo, nombre del jefe directo.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">5. Datos de SMS</p>
                    <ul>
                        <li>
                            Los mensajes SMS de carácter financiero que tienes guardados en tu dispositivo —entre ellos figuran marcas de tiempo, números telefónicos y el propio contenido de los mensajes— no implican que se recojan datos de tus SMS que no sean de índole financiera, ni que su contenido sea compartido. Estos datos son tratados a través de modelos automatizados para valorar solicitudes de préstamo, y se incorporan a nuestros sistemas de gestión de riesgos con el objetivo de establecer si cumples con los requisitos para acceder a nuestros servicios financieros.
                        </li>
                        <li>
                            ArreCredi lo mantendrá informado enviándole alertas por mensaje de texto que contienen recordatorios de facturación, actualizaciones del ciclo de vida del préstamo y campañas promocionales personalizadas. La función de lectura de SMS se implementa con el único propósito de verificar automáticamente los códigos OTP enviados a su dispositivo móvil.
                        </li>
                        <li>
                            Los datos se transfieren a nuestro servidor https://arredata.arrecredi.net.
                        </li>
                        <li>
                            Nunca compartiremos sus datos con terceros sin su consentimiento.
                        </li>
                        <li>
                            Para eliminar sus datos, envíe una solicitud a .
                        </li>
                    </ul>
                    <p style="font-weight: bold;">6. Correo electrónico</p>
                    <ul>
                        <li>
                            se usará únicamente para la atención de consultas de los usuarios, con el fin de dar respuesta oportuna a sus preguntas y solicitudes. Mantendremos absoluta confidencialidad de sus datos personales y no los revelaremos en ningún caso a terceros.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">7. Datos de Cónyuge o Concubina</p>
                    <ul>
                        <li>
                            Nombre completo, dirección, ocupación, teléfonos de contacto, estado civil, género, país, fecha de nacimiento.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">8. Datos Bancarios o Patrimoniales</p>
                    <ul>
                        <li>
                            Institución bancaria, número de cuenta, CLABE, tipo de cuenta, sucursal.
                        </li>
                        <li>
                            Huella, foto y firma digital.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">9. Datos de Ubicación</p>
                    <ul>
                        <li>
                            Información de ubicación aproximada de su dispositivo para gestionar solicitudes de préstamo y reducir riesgos.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">10. Datos del Dispositivo</p>
                    <ul>
                        <li>
                            Modelo de hardware, RAM, identificadores únicos (IMEI, número de serie, SSAID, AAID), información SIM.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">11. Almacenamiento (solo fotos de galería)</p>
                    <ul>
                        <li>
                            Acceso a la galería para seleccionar y cargar imágenes requeridas en la solicitud de préstamo.
                        </li>
                        <li>
                            Las fotos se almacenan cifradas por 1 año.
                        </li>
                        <li>
                            Para eliminar sus fotos, contacte a
                        </li>
                    </ul>
                    <p style="font-weight: bold;">12. Cámara / Información de Imagen</p>
                    <ul>
                        <li>
                            Permiso de cámara para tomar fotos de su documento de identidad y rostro en vivo.
                        </li>
                        <li>
                            No accedemos a su galería de imágenes.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">13. Datos de Contactos</p>
                    <ul>
                        <li>
                            Nombre y número de teléfono para comunicación efectiva en caso de préstamos vencidos.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">14. Permisos del Dispositivo</p>
                    <ul>
                        <li>
                            Información emitida tras la activación de permisos de SMS, ubicación, cámara y calendario.
                        </li>
                    </ul>
                    <p>
                        <span style="font-weight: bold;">Nota:</span>YOONA no recaba datos sensibles (origen racial, estado de salud, creencias religiosas, preferencias sexuales, etc.). Tampoco venderá sus datos personales ni los utilizará para publicidad dirigida.
                    </p>

                    <p style="font-weight: bold;">III. Finalidades del Tratamiento</p>
                    <p>
                        Los datos personales se utilizarán para:
                    </p>
                    <ul>
                        <li>
                            Verificar y confirmar su identidad.
                        </li>
                        <li>
                            Realizar análisis de riesgos.
                        </li>
                        <li>
                            Cumplir con obligaciones contractuales y regulatorias.
                        </li>
                        <li>
                            Mantener su información actualizada.
                        </li>
                        <li>
                            Formalizar contratos derivados de la relación comercial.
                        </li>
                        <li>
                            Validar identidad mediante medios biométricos y biográficos.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">IV. Mecanismos para manifestar negativa al Tratamiento</p>
                    <p>
                        Si no está de acuerdo con este Aviso de Privacidad, tiene 5 días hábiles para manifestar su negativa al tratamiento de sus datos personales. Envíe un correo a  con el asunto “Negativa para el Tratamiento de Datos Personales” e incluya sus datos de identificación.
                    </p>

                    <p style="font-weight: bold;">V. Transferencia de Datos</p>
                    <p>YOONA podrá transferir sus datos personales a terceros, asegurándose de que estos respeten los términos de este Aviso. Los datos podrán ser transferidos a:  </p>
                    <ul>
                        <li>
                            Sociedades prestadoras de servicios (Trans Unión de México, Círculo de Crédito, etc.).
                        </li>
                        <li>
                            Autoridades mexicanas y extranjeras.
                        </li>
                        <li>
                            Incode Technologies, Inc. (validación de identidad).
                        </li>
                        <li>
                            Adjust GmbH (análisis de comportamiento de usuarios).
                        </li>
                    </ul>
                    <p>
                        Si no desea que sus datos sean transferidos, cierre su cuenta o envíe un correo a .
                    </p>

                    <p style="font-weight: bold;">VI. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)</p>
                    <p>Usted puede ejercer sus derechos ARCO enviando una solicitud a  o presentándose en nuestras oficinas en Av. P.º de la Reforma 222, Juárez, Cuauhtémoc, 06600 Ciudad de México, CDMX </p>
                    <p style="font-weight: bold;">VII. Modificaciones al Aviso de Privacidad</p>
                    <p>
                        YOONA se reserva el derecho de modificar este Aviso de Privacidad.
                    </p>
                    <p style="font-weight: bold;">VIII. Revocación del Consentimiento</p>
                    <p>
                        Puede revocar su consentimiento en cualquier momento siguiendo el procedimiento descrito en la sección VI.
                    </p>
                    <p style="font-weight: bold;">IX. Atención de Quejas y Denuncias</p>
                    <p>
                        Si considera que sus derechos han sido vulnerados, puede acudir al Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI).
                    </p>
                    <p style="font-weight: bold;">X. Contacto</p>
                    <p>Para dudas o aclaraciones, contáctenos:  </p>
                    <ul>
                        <li><span style="font-weight: bold;">Teléfono:</span>5594484815</li>
                        <li><span style="font-weight: bold;">Email:</span>  (respuesta en 2-3 días hábiles).</li>
                        <li><span style="font-weight: bold;">Horario:</span> Lunes a viernes 9:00-18:30, sábado y domingo 9:00-14:30. </li>
                    </ul>
                    <p>
                        Este Aviso de Privacidad está diseñado para garantizar la protección y el uso responsable de sus datos personales. Agradecemos su confianza en <span style="font-weight: bold;">YOONA TECH, S.A. DE C.V.</span> y Arrecredi.
                    </p>
                </div>
            </div>
        </div>
        <footPage></footPage>
    </div>
</template>

<script>

    import $ from 'jquery';
    import headNav from "@/components/headNav.vue";
    import footPage from "@/components/foot.vue";
    import "../components/scss/Aviso.scss";

    export default {
        name: "loan",
        components: { headNav, footPage },
        data() {
            return {
                scroll: 0,
                activeName: 'first',
            }
        },
        mounted(){
            document.documentElement.scrollTop = 0;
            window.addEventListener('scroll',this.handleScroll);
            if(this.$route.query.activeName){
                this.activeName = this.$route.query.activeName;
            }
            this.$nextTick(() => {
                $('.el-tabs__active-bar').css({
                    width: '150px'
                })
            });


        },
        methods: {
            handleClick(tab, event){
                console.log(tab)
                console.log(event)
                this.$nextTick(() => {
                    setTimeout(() => {
                        $('.el-tabs__active-bar').css({
                            width: '150px'
                        })
                    }, 100)
                });
            },
            handleScroll(){
                //或者使用document.querySelector('.class或者#id').scrollTop
                this.scroll = document.documentElement.scrollTop||document.body.scrollTop
            },
        },
        //销毁,否则跳到别的路由还是会出现
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style>
    .title p span {
        border-bottom: 3px solid #4e67f1;
    }
    .arrecredi_home_banner{
        width: 100%;
        height: 402px;
        position: relative;
        overflow: hidden;
        z-index: 2;
    }
    .bigContent .el-tabs__item{
        height: 58px;
        font-weight: bold;
        font-size: 32px;
        color: #262A48;
    }
    .bigContent .el-tabs__item:hover{
        color: #262A48;
    }
    .bigContent .el-tabs__active-bar{
        height: 3px;
        background: #262A48;
    }
    .bigContent .el-tabs__item.is-active{
        color: #262A48;
    }
    .bigContent .el-tabs__nav-wrap::after{
        height: 0;
    }
    #tab-first{
        width: 495px;
    }
    .arrecrediprivacidad_view{
        width: 100%;
        padding: 50px 0 0 0;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
        .bigContent {
            width: 100%;
            box-sizing: border-box;
            padding: 0 16px;
        }
        .bigContent .el-tabs__item {
            font-size: 18px;
            height: 48px;
            padding: 0 12px;
        }
        #tab-first {
            width: auto;
        }
        .arrecrediprivacidad_view {
            padding: 30px 16px 0 16px;
        }
        .arrecrediprivacidad_view .content {
            font-size: 14px;
            line-height: 22px;
        }
        .arrecrediprivacidad_view p,
        .arrecrediprivacidad_view li {
            margin-bottom: 12px;
        }
        .arrecredi_home_banner {
            height: 200px;
        }
    }
</style>

